import { action, orchestrator } from 'satcheljs';
import { getStore } from '../store/store';
import { OptionSubCategory } from 'owa-options-core';
import updateCategory from '../orchestrators/updateCategory';

const selectSubcategory = action('selectSubcategory', (subcategory: OptionSubCategory) => ({
    subcategory,
}));

export default selectSubcategory;

orchestrator(selectSubcategory, actionMessage => {
    const store = getStore();
    updateCategory(store.currentCategoryKey, actionMessage.subcategory.key, null);
});
